'use client';

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  type CarouselApi,
} from '@ahafood/ui/components/carousel';
import type { ComponentProps, ReactNode } from 'react';

/**
 * Free-drag horizontal carousel (Embla `dragFree: true`).
 * Dùng cho list scroll ngang không cần snap: category, deals, stores, items.
 *
 * Replace `FreeModeSwiper` (default mode) — same use case nhưng dùng Embla.
 */
interface FreeDragCarouselProps {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  opts?: ComponentProps<typeof Carousel>['opts'];
  setApi?: (api: CarouselApi) => void;
}

export function FreeDragCarousel({
  children,
  className,
  contentClassName,
  opts,
  setApi,
}: FreeDragCarouselProps) {
  return (
    <Carousel
      opts={{ dragFree: true, containScroll: 'trimSnaps', ...opts }}
      setApi={setApi}
      className={className}
    >
      <CarouselContent className={contentClassName}>{children}</CarouselContent>
    </Carousel>
  );
}

FreeDragCarousel.Item = CarouselItem;
